module.exports = __webpack_public_path__ + "static/y-combinator-35af425304c48ceb79e075854a6b290a.jpg";